import config from '../../config';

export default {
  url: `${config.api
    .baseURL}/accounts/:accountId/profiles/:profileId/questions`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/questions/list.js